import { CheckNotes, InspectionCase } from '../../inspection-cases';

export class RacksAndReinforcementDto extends InspectionCase {
  racksFixed?: InspectionCase;
  distancesBetweenRacksAccordingSpec?: InspectionCase;
  distanceBetweenLastRackAndpipeAccordingSpec?: InspectionCase;
  raiserReinforcementsAccordingSpec?: InspectionCase;
}

export class RacksAndReinforcement extends RacksAndReinforcementDto {
  constructor(
    data: RacksAndReinforcementDto = {
      title: 'מתלים ואמצעי חיזוק'
    }
  ) {
    super(data);
    this.racksFixed = new InspectionCase({
      ...data.racksFixed,
      title: `המתלים תיקניים ומאושרים`
    });
    this.distancesBetweenRacksAccordingSpec = new InspectionCase({
      ...data.distancesBetweenRacksAccordingSpec,
      title: `המרחקים בין המתלים בהתאם לדרישות התקן`
    });
    this.distanceBetweenLastRackAndpipeAccordingSpec = new InspectionCase({
      ...data.distanceBetweenLastRackAndpipeAccordingSpec,
      title: `המרחקים בין מתלה אחרון לסוף הצינור  בהתאם לדרישות התקן`
    });
    this.raiserReinforcementsAccordingSpec = new InspectionCase({
      ...data.raiserReinforcementsAccordingSpec,
      title: `חיזוקים לרייזרים  בהתאם לדרישות התקן`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.racksFixed.isApplicable || this.racksFixed.isPassed) &&
        (!this.distancesBetweenRacksAccordingSpec.isApplicable ||
          this.distancesBetweenRacksAccordingSpec.isPassed) &&
        (!this.distanceBetweenLastRackAndpipeAccordingSpec.isApplicable ||
          this.distanceBetweenLastRackAndpipeAccordingSpec.isPassed) &&
        (!this.raiserReinforcementsAccordingSpec.isApplicable ||
          this.raiserReinforcementsAccordingSpec.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.racksFixed.getNotes(),
      ...this.distancesBetweenRacksAccordingSpec.getNotes(),
      ...this.distanceBetweenLastRackAndpipeAccordingSpec.getNotes(),
      ...this.raiserReinforcementsAccordingSpec.getNotes()
    ];
  }
}
